// extracted by mini-css-extract-plugin
export default {"container":"GameEnd_container__jJFd2"};